import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { EXCEPTION_TYPES, UsageRate, UsageRatePatch } from '../../models/usage-rate';
import { TextFieldModule } from '@angular/cdk/text-field';
import { KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-update-usage-rate-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, TextFieldModule, KeyValuePipe],
  templateUrl: './update-usage-rate-dialog.html',
  styleUrl: './update-usage-rate-dialog.css',
})
export class UpdateUsageRateDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<UpdateUsageRateDialog>,
    @Inject(MAT_DIALOG_DATA) public usageRate: UsageRate
  ) { }

  private _snackBar = inject(MatSnackBar);
  private formBuilder = inject(FormBuilder);

  readonly exceptionTypes = EXCEPTION_TYPES;

  usageRateForm = this.formBuilder.group({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    type: new FormControl<string|null>(null)
  });

  ngOnInit() {
    this.usageRateForm.get('name')?.setValue(this.usageRate.name);
    this.usageRateForm.get('description')?.setValue(this.usageRate.description);

    if(this.usageRate.is_exception) {
      this.usageRateForm.get('type')?.setValue(this.usageRate.type ?? null);
    }
  }

  submit() {
    const usageRatePatch: UsageRatePatch = this.usageRateForm.value as UsageRatePatch;
    
    this.backendApi.patchUsageRate(this.usageRate.uuid, usageRatePatch).subscribe({
      next: (patchedUsageRate) => {
        this._snackBar.open("Grille de vente modifiée.");
        this.dialogRef.close(patchedUsageRate);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la modification de la grille de vente.");
      }
    })
  }
}
